import { Button } from "antd"
import { DownOutlined } from "@ant-design/icons"

const ExpandButton = ({ onClick, selected, size = "small", type = "text", disabled = false, style = {} }) => {

  return <Button
    onClick={onClick}
    size={size}
    type={type}
    disabled={disabled}
    icon={<DownOutlined
      style={{
        transition: 'transform 0.3s',
        transform: selected ? 'rotate(180deg)' : 'rotate(0deg)',
        ...style
      }}
    />}
  />
}

export default ExpandButton